"use client";

import { addVehicle } from "action/garage/addVehicle";
import AmpService, { AMP_SELECT_VEHICLE_LOCATIONS } from "analytics/amplitude/amplitudeEvents";
import classNames from "classnames";
import CategoryVehicleBannerSection from "component/category/category-vehicle-banner-section/CategoryVehicleBannerSection";
import BoxedVehicleSelector from "component/vehicle-form/BoxedVehicleSelector";
import { RootState } from "interfaces/generics.type";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";
import isHighTrafficPage from "util/helper/isHighTrafficPage";
import isHomePage from "util/helper/isHomePage";
import { scrollTo } from "util/scroll-helper";
import getFocusEl from "util/vehicle/getFocusEl";
import useScreenSize from "../../../hoc/useScreenSize";
import { getVehicleSelectionOrder } from "../../../util/vehicle/get-vehicle-selection-order";
import { validateVehicle } from "../../../util/vehicle/validate-vehicle";
import HomeGarageCompactVehicleSelected from "./HomeGarageCompactVehicleSelected";
import HomeGarageLabel from "./HomeGarageLabel";
import HomeGarageRegularVehcileSelecetd from "./HomeGarageRegularVehicleSelected";
import homeGarageStyles from "./StyledHomeGarage.module.scss";
import styles from "./homeGarage.module.scss";

function HomeGarage(props: any) {
  const {
    isCompactGarage, defaultMake, defaultModel, defaultYear,
    fitmentOptionsDetails, fitmentOptionsPrompt,
  } = props;
  const dispatch = useDispatch();
  const [isMobile, isTablet] = useScreenSize();

  const { selectedVehicle } = useSelector((state: RootState) => state.garage);
  const isValidVehicle = validateVehicle(selectedVehicle);
  const selectionOrder = getVehicleSelectionOrder(defaultMake, defaultModel, defaultYear);
  const focusEl = getFocusEl(selectionOrder, { defaultMake, defaultModel, defaultYear });

  const router = useRouter();
  const { pathname } = router;
  const isItHomePage = isHomePage(pathname);
  const isItHighTrafficPage = isHighTrafficPage(router);

  if (!isValidVehicle) {
    return (
      <div
        className={classNames(homeGarageStyles.StyledHomeGarage, styles.home_garage, {
          [styles.home_garage_height]: isCompactGarage,
          [homeGarageStyles.category_page_vehicle_selector]: !isItHomePage && !isItHighTrafficPage,
        })}
        data-testid="home-garage"
      >
        <HomeGarageLabel isCompactGarage={isCompactGarage} />
        <BoxedVehicleSelector
          className={classNames("home-garage-inputs", styles.home_garage_inputs, {
            // "p-t-20": isCompactGarage,
            [styles.compact_garage_input]: isCompactGarage,
          })}
          onSelectVehicle={(vehicle: any) => {
            AmpService.vehicleChange(vehicle, AMP_SELECT_VEHICLE_LOCATIONS.HOME_PAGE_BANNER);
            dispatch(addVehicle(vehicle));
            scrollTo("anchor-tab-category");
          }}
          defaultMake={defaultMake}
          defaultModel={defaultModel}
          defaultYear={defaultYear}
          selectionOrder={selectionOrder}
          focusEl={focusEl}
          newStyles={false}
        />
      </div>
    );
  }
  if (isValidVehicle && !isItHomePage && !isItHighTrafficPage) {
    return (
      <div className="d-flex align-items-center flex-column justify-content-center" style={{ height: "100%" }}>
        <CategoryVehicleBannerSection />
      </div>
    );
  }

  if (isValidVehicle) {
    if (isMobile || isTablet) {
      return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: isCompactGarage ? 145 : 237 }}>
          <HomeGarageCompactVehicleSelected
            isCompactGarage={isCompactGarage}
            onChangeVehicle={() => scrollTo("anchor-tab-category")}
          />
        </div>
      );
    }
    return (
      <HomeGarageRegularVehcileSelecetd
        isCompactGarage={isCompactGarage}
        onChangeVehicle={() => scrollTo("anchor-tab-category")}
        fitmentOptionsDetails={fitmentOptionsDetails}
        fitmentOptionsPrompt={fitmentOptionsPrompt}
      />
    );
  }
}

export default HomeGarage;
